import { CSSObject } from '@chakra-ui/react';

export const ExoticsWrapper: CSSObject = {
  p: '2',
};

export const ExoticsContainer: CSSObject = {
  p: '2',
  border: '1px',
  borderColor: 'alpha.200',
  bg: 'alpha.50',
  borderRadius: 'base',
};

export const CheckboxBoxed: CSSObject = {
  justifyContent: 'flex-end',
  mr: '3',
};

export const SelectFieldContainer: CSSObject = {
  w: 'unset',
};
